import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    inject,
    NgZone,
    OnDestroy,
    OnInit,
    QueryList,
    signal,
    ViewChild,
    ViewChildren,
    WritableSignal
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {GoogleMap} from '@angular/google-maps';
import {CodaltComponent} from '../codalt/codalt.component';
import {FormControl, UntypedFormGroup} from '@angular/forms';
import {Project} from '../../classes/project';
import {ProjectService} from '../../services/project.service';
import {combineLatest, filter, from, mergeMap, of, reduce, startWith, Subject} from 'rxjs';
import {TtmType} from '../../classes/ttmtype';
import {TtmService} from '../../services/ttm.service';
import {TtmStatus} from '../../classes/ttmstatus';
import {Ttm} from '../../classes/ttm';
import {MatExpansionPanel} from '@angular/material/expansion';
import {debounceTime, map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {TtmTicketDialogComponent} from '../ttm-ticket-dialog/ttm-ticket-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TtmDetailsDialogComponent} from '../ttm-details-dialog/ttm-details-dialog.component';
import {Utils} from '../../utils.class';
import {Entity} from '../../classes/entity';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MapMutatorComponent} from './map-mutator/map-mutator.component';
import * as turf from '@turf/turf';
import {TtmMergeComponent} from '../ttm-merge/ttm-merge.component';
import {Workorder} from '../../classes/workorder';
import {WorkorderService} from '../../services/workorder.service';
import {TtmStatusDialogComponent} from '../ttm-status-dialog/ttm-status-dialog.component';
import {Title} from '@angular/platform-browser';
import {TtmHistoryDialogComponent} from '../ttm-history-dialog/ttm-history-dialog.component';
import {Platform} from '@angular/cdk/platform';
import {TtmImage} from '../../classes/ttmimage';
import {TtmImageService} from '../../services/ttm-image.service';
import {CameraFlowService, ResumedCameraFlow} from '../../services/camera-flow.service';
import {LoggerService} from '../../services/logger.service';
import {ImageViewerComponent} from '../image-viewer/image-viewer.component';
import {TtmSplitComponent} from '../ttm-divide/ttm-split.component';
import _ from 'lodash';
import {TtmTypes} from '../../classes/ttm-types.enum';
import {DrawingService} from '../../services/drawing.service';
import {DrawingMap} from '../../classes/drawing-map';
import {LocalStorage} from '../../utils/storage';
import {Settings} from '../../settings/settings';
import {Routenames} from '../../routenames';
import {MatMenuTrigger} from '@angular/material/menu';
import LatLngBounds = google.maps.LatLngBounds;
import MapTypeId = google.maps.MapTypeId;

@Component({
    selector: 'app-google-maps',
    templateUrl: './google-maps.component.html',
    styleUrl: './google-maps.component.scss'
})
export class GoogleMapsComponent extends CodaltComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatMenuTrigger) mapMenuTrigger: MatMenuTrigger;

    get composingWorkorder(): Workorder {
        return this._composingWorkorder;
    }

    set composingWorkorder(value: Workorder) {
        this._composingWorkorder = value;
        if (this.fgDrawings && this._composingWorkorder.drawings.length > 0) {
            this.fgDrawings.setValue(
                Object.keys(this.fgDrawings.controls).reduce((acc, drawingId) => {
                    acc[drawingId] = !!this._composingWorkorder.drawings.find(wod => wod.drawing_id === +drawingId);
                    return acc;
                }, {})
            );
        }
    }

    private _snackBar = inject(MatSnackBar);
    private location = inject(Location);
    private cameraFlow = inject(CameraFlowService);
    private logger = inject(LoggerService);
    private ttmZoomInterval: ReturnType<typeof setInterval>;

    private closeMapMenuTimeout?: number;

    mapTypeId: string = 'roadmap';

    /** BGT tiles are only available from zoom 17. Below that, fall back to the regular Google Maps roadmap type instead of the PDOK achtergrondkaart. */
    get effectiveMapTypeId(): string {
        if (this.mapTypeId === 'BGT' && this.actualZoom < 17) {
            return google.maps.MapTypeId.ROADMAP;
        }
        return this.mapTypeId;
    }
    options: google.maps.MapOptions = {
        mapId: '55a928ad53a65407',
        center: {lat: 52.5, lng: 5},
        zoom: 12,
        tilt: 0,
        headingInteractionEnabled: false,
        isFractionalZoomEnabled: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        restriction: Utils.RestrictToNl()
    };
    center: { lat: number; lng: number };
    actualZoom: number;
    bounds: LatLngBounds;
    setZoom: number;
    start: number;
    ttmTypes: TtmType[];
    ttmStatuses: TtmStatus[];
    filteredTtms: Ttm[];
    scopedTtms: Ttm[];
    selectedTtm: Ttm;
    filteredEntities: Entity[];
    @ViewChild('googleMap') googleMap: GoogleMap;
    @ViewChild('ttmList') ttmList: ElementRef;
    @ViewChildren(MatExpansionPanel, {read: ElementRef}) panels: QueryList<ElementRef>;
    viewState = {
        workorder: false,
        filter: false,
        ttms: false,
        search: false,
        satellite: false,
        vakmanMode: false,
        gpsFailure: false,
        imageDrawer: false
    };

    project: Project;
    fgType: UntypedFormGroup;
    fgWorkorder: UntypedFormGroup;
    fcWorkorderAll: FormControl<boolean>;
    fcWorkorderIncluding: FormControl<boolean>;
    fcTypeAll: FormControl<boolean>;
    fcOtherAll: FormControl<boolean>;
    fcStatusAll: FormControl<boolean>;
    fgDrawings: UntypedFormGroup;
    fgStatus: UntypedFormGroup;
    fgOther: UntypedFormGroup;
    fcSelectedTtm: FormControl<number>;
    fcHideOutsideWorkorder: FormControl<boolean>;
    projectId: number;
    workorder: Workorder;
    contextMenuTimeout: any;
    gpsLocation: { lat: number; lng: number; };
    ttmImagesMap = new Map<number, TtmImage[]>();
    ttmImagesWithMultiple: TtmImage[] = [];
    imageDrawerCurrentImage: TtmImage = null;
    loadingTtmImagesWithMultiple = false;
    ttmImageDistance = new Map<number, string>();
    private gpsWatchId: any;
    private _composingWorkorder: Workorder;
    isMobileViewport = false;
    menuOpen = false;

    mapPolygonConfigMap: Map<string, google.maps.PolygonOptions>;
    mapPolylineConfigMap: Map<string, google.maps.PolylineOptions>;

    fcSearch = new FormControl<string>(null);
    searchResults: Ttm[];

    activeTtm: Ttm;

    selectionPolygon: { lat: number, lng: number }[];
    selectionEnabled = false;
    viaWorkorder: number;
    viaTicket: number;

    ttmUpdateSubject: Subject<any> = new Subject<any>();

    historyMarkers: WritableSignal<any[]> = signal<any[]>([]);

    linetypeNameMap: Map<string, string>;

    selectedDrawingMaps: DrawingMap[] = [];
    private activeDrawingMapOverlays = new Map<number, google.maps.ImageMapType>();

    @HostBinding('class.mobile-controls') mobileControls = false;

    @ViewChild(MapMutatorComponent) mapMutator: MapMutatorComponent;

    @HostBinding('style.--ttm-toggle-width') ttmToggleWidth: string;
    private ttmToggleResizeObserver = new ResizeObserver(([entry]) => {
        const width = (entry.target as HTMLElement).offsetWidth;
        this.ngZone.run(() => this.ttmToggleWidth = width > 0 ? `${width}px` : null);
    });

    @ViewChild('ttmListToggle') set ttmListToggle(toggle: ElementRef<HTMLElement>) {
        this.ttmToggleResizeObserver.disconnect();
        if (toggle) {
            this.ttmToggleResizeObserver.observe(toggle.nativeElement);
        }
    }

    constructor(private ngZone: NgZone,
                private cdref: ChangeDetectorRef,
                private router: Router,
                private dialog: MatDialog,
                private activeRoute: ActivatedRoute,
                private matSnackBar: MatSnackBar,
                private projectService: ProjectService,
                private ttmService: TtmService,
                private workorderService: WorkorderService,
                private drawingService: DrawingService,
                private confirmDialog: ConfirmDialogService,
                private breakpointObserver: BreakpointObserver,
                private platformService: Platform,
                private ttmImageService: TtmImageService,
                private title: Title) {
        super();
    }

    toggleTtmList() {
        this.viewState.ttms = !this.viewState.ttms;
    }

    ngOnInit() {
        this.linetypeNameMap = TtmService.lineTypeNameMap;
        this.setupGeo();
        this.subscriptions.add(this.breakpointObserver.observe([
            '(max-width: 850px)'
        ]).subscribe(result => {
            this.mobileControls = result.matches;
        }));

        this.subscriptions.add(this.breakpointObserver.observe([
            '(max-width: 768px)'
        ]).subscribe(result => {
            this.isMobileViewport = result.matches;
        }));

        const queryParams = this.activeRoute.snapshot.queryParams as {
            ttm: number,
            drawing: number,
            executeWorkorder: number;
            workorder: number;
            ticket: number;
            withRemark: string
        };
        const params = this.activeRoute.snapshot.params as { projectId: number };
        this.viaWorkorder = +(queryParams.executeWorkorder ?? queryParams.workorder);
        this.viaTicket = +queryParams.ticket;
        this.viewState.workorder = !!queryParams.workorder;

        this.viewState.vakmanMode = !!queryParams.executeWorkorder;
        this.projectId = params.projectId ? +params.projectId : null;
        const withRemarkFilter = queryParams.withRemark === 'true' || queryParams.withRemark === '1';
        const statuses$ = this.ttmService.statuses();
        const types$ = this.ttmService.types();
        const workOrder$ = queryParams.executeWorkorder ? this.workorderService.getWorkorder(+queryParams.executeWorkorder) : of(false);
        const project$ = this.projectService.get(this.projectId, this.viewState.vakmanMode);

        const getDrawingDate = (drawingId) => {
            this.subscriptions.add(combineLatest([statuses$, types$, project$, workOrder$]).subscribe(([statuses, types, projectResponse, workorder]) => {
                this.ttmStatuses = statuses.data;
                this.ttmTypes = types.data;
                this.project = projectResponse.data;


                if (typeof workorder !== 'boolean') {
                    this.workorder = workorder.data;
                    this.title.setTitle('▶ ' + this.workorder.id_4ps + ' - uitvoeren werkopdracht - TSNed App');
                    this.project.drawings = this.workorder.drawings.filter(wod => !!wod.drawing).map(wod => wod.drawing);
                    this.project.workorders = [this.workorder];
                } else {
                    this.title.setTitle('▶ ' + this.project.id_4ps + ' - TSNed App');
                }

                if (this.viewState.vakmanMode) {
                    this.project.drawings = this.project.drawings?.filter(d => d.entities_count > 0);
                }
                this.setupSearchForms(drawingId, withRemarkFilter);
                this.setupMap();
            }));
        };

        // After the app was reloaded while the user was changing the status of a ttm, we bring him back to that dialog.
        // resume() logs right away, before anything is loaded: `interrupted` or `resumed_idle`, with the ttmId.
        // Only the failures further down (`resume_failed`) can come later.
        // The flow as it is in localStorage now: resume() can change or clear it, so read it first
        const storedFlow = this.cameraFlow.peek();
        const resumeFlow = this.cameraFlow.resume(this.projectId);
        const ttmId = resumeFlow?.ttmId ?? (+queryParams.ttm > 0 ? +queryParams.ttm : null);

        if (ttmId) {
            // Log right away that we ended up here with a stored camera flow (tsned_camera_flow), whether or not the
            // resume works out. Ideally this does not happen: it means the app was reloaded or crashed during a flow.
            this.cameraFlow.mapOpenedWithTtm(storedFlow, {
                ttmId,
                projectId: this.projectId,
                source: resumeFlow ? 'resume_flow' : 'url',
                resumable: !!resumeFlow,
                vakmanMode: this.viewState.vakmanMode,
            });
            this.subscriptions.add(this.drawingService.getDrawingByTtmId(ttmId).subscribe({
                next: drawing => getDrawingDate(drawing.data?.id ?? queryParams.drawing),
                // A ttm in the url that no longer exists must not keep the map from loading
                error: () => getDrawingDate(queryParams.drawing),
            }));
            let attempts = 0;
            this.ttmZoomInterval = setInterval(() => {
                if (this.filteredTtms?.length > 0) {
                    clearInterval(this.ttmZoomInterval);
                    this.zoomToTtmId(ttmId);
                    if (resumeFlow) {
                        this.resumeStatusDialog(resumeFlow);
                    }
                } else if (++attempts > 120) {
                    clearInterval(this.ttmZoomInterval);
                    if (resumeFlow) {
                        this.logger.logEvent('CAMERA_FLOW', 'resume_failed', {reason: 'ttms_not_loaded', flowId: resumeFlow.flowId, ttmId});
                        this.cameraFlow.clear();
                    }
                }
            }, 500);
        } else {
            getDrawingDate(queryParams.drawing);
        }
    }

    ngAfterViewInit() {
        this.subscriptions.add(this.googleMap?.zoomChanged.subscribe(() => {
            this.actualZoom = this.googleMap?.getZoom() ?? 99;
        }));
        this.subscriptions.add(this.googleMap?.boundsChanged.subscribe(() => {
            this.bounds = this.googleMap.getBounds();
        }));
        this.subscriptions.add(this.googleMap?.maptypeidChanged.subscribe(() => {
            const newMapTypeId = this.googleMap.getMapTypeId();
            // Ignore the automatic BGT -> roadmap fallback triggered by effectiveMapTypeId when zoomed out
            if (this.mapTypeId === 'BGT' && newMapTypeId === google.maps.MapTypeId.ROADMAP) {
                return;
            }
            this.mapTypeId = newMapTypeId as MapTypeId;
        }));


    }

    private setupMap() {
        setTimeout(() => {
            this.ngZone.runOutsideAngular(() => {
                google.maps.importLibrary('maps').then(() => {
                    setTimeout(() => {
                        this.mapPolylineConfigMap = new Map<string, google.maps.PolylineOptions>([
                            ['geluidsscherm', {
                                strokeWeight: 8,
                                strokeColor: '#ff7f00',
                                zIndex: 2
                            }], ['arrow', {
                                strokeColor: '#ff0000',
                                strokeWeight: 2,
                                zIndex: 3,
                                icons: [{
                                    icon: {
                                        path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
                                        scale: 2,
                                        strokeColor: '#ff0000',
                                        fillColor: '#ffffff',
                                        fillOpacity: 0
                                    },
                                    offset: '0%'
                                }]
                            }], ['bouwhek', {
                                strokeColor: '#ff7f00',
                                strokeWeight: 2,
                                strokeOpacity: 1,
                                zIndex: 2,
                                icons: [{
                                    icon: {
                                        path: google.maps.SymbolPath.CIRCLE,
                                        scale: 2,
                                        fillColor: '#ff7f00',
                                        fillOpacity: 1,
                                        strokeColor: '#ff7f00',
                                        strokeWeight: 1
                                    },
                                    offset: '0%',
                                    repeat: '20px'
                                }]
                            }], ['barrier', {
                                zIndex: 2,
                                strokeColor: '#ff0000',
                                strokeWeight: 4,
                                strokeOpacity: 1
                            }], ['markering', {
                                zIndex: 2,
                                strokeColor: '#ff003f',
                                strokeWeight: 4,
                                strokeOpacity: 1
                            }]
                        ]);
                        this.mapPolygonConfigMap = new Map<string, google.maps.PolygonOptions>([
                            ['drawingZoomDark', {
                                strokeColor: '#fafe39',
                                strokeOpacity: 0.525,
                                strokeWeight: 1,
                                fillColor: '#fafe39',
                                fillOpacity: 0.525
                            }],
                            ['drawingZoomDark', {
                                strokeColor: '#fafe39',
                                strokeOpacity: 0.525,
                                strokeWeight: 1,
                                fillColor: '#fafe39',
                                fillOpacity: 0.525
                            }],
                            ['drawingZoomLight', {
                                strokeColor: '#fafe39',
                                strokeOpacity: 0.19,
                                strokeWeight: 1,
                                fillColor: '#fafe39',
                                fillOpacity: 0.19
                            }],
                            ['werkvak', {zIndex: 1, strokeColor: '#6fff00', strokeOpacity: 1, strokeWeight: 1, fillColor: '#6fff00', fillOpacity: 0.225}],
                            ['tijdelijke verharding', {
                                zIndex: 1,
                                strokeColor: '#dfff7f',
                                strokeOpacity: 1,
                                strokeWeight: 1,
                                fillColor: '#dfff7f',
                                fillOpacity: 0.9
                            }],
                            ['selectionPolygon', {
                                strokeColor: '#000000',
                                strokeOpacity: 1,
                                strokeWeight: 2,
                                fillColor: '#dfff7f',
                                fillOpacity: 0.5,
                                zIndex: 999
                            }],
                            ['werkvak', {zIndex: 1, strokeColor: '#6fff00', strokeOpacity: 1, strokeWeight: 1, fillColor: '#6fff00', fillOpacity: 0.225}],
                            ['markering-vlak', {zIndex: 1, strokeColor: '#fff400', strokeOpacity: 1, strokeWeight: 1, fillColor: '#fff400', fillOpacity: 1}],
                        ]);

                        this.googleMap.mapTypes.set('BGT', new google.maps.ImageMapType({
                            getTileUrl: function (coord, zoom) {
                                var tilesPerGlobe = 1 << zoom;
                                var x = coord.x % tilesPerGlobe;
                                if (x < 0) {
                                    x = tilesPerGlobe + x;
                                }
                                return `https://maps.codalt.com/gwc/service/tms/1.0.0/pdok:BGT@WebMercatorQuad@png/${zoom}/${coord.x}/${coord.y}.png?flipY=true`;
                            },
                            tileSize: {width: 256, height: 256} as google.maps.Size,
                            name: 'BGT Layer',
                            maxZoom: 21,
                            minZoom: 7
                        }));

                        this.googleMap.mapTypes.set('OSM', new google.maps.ImageMapType({
                            getTileUrl: function (coord, zoom) {
                                // "Wrap" x (longitude) at 180th meridian properly
                                // NB: Don't touch coord.x: because coord param is by reference, and changing its x property breaks something in Google's lib
                                var tilesPerGlobe = 1 << zoom;
                                var x = coord.x % tilesPerGlobe;
                                if (x < 0) {
                                    x = tilesPerGlobe + x;
                                }
                                // Wrap y (latitude) in a like manner if you want to enable vertical infinite scrolling
                                return 'https://tile.openstreetmap.de/' + zoom + '/' + x + '/' + coord.y + '.png';
                            },
                            tileSize: {width: 256, height: 256} as google.maps.Size,
                            name: 'OpenStreetMap',
                            maxZoom: 19
                        }));

                    });
                });
            });
        });
    }

    private buildDrawingMapImageType(drawingMap: DrawingMap): google.maps.ImageMapType {
        return new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) => {
                if (zoom < 17) {
                    return 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
                }
                return this.geoServerTileUrl(drawingMap.workspace, drawingMap.layer, zoom, coord.x, coord.y);
            },
            tileSize: {width: 256, height: 256} as google.maps.Size,
            name: drawingMap.layer,
            maxZoom: 22,
            minZoom: 17,
            opacity: 1
        });
    }

    toggleDrawingMapOverlay(drawingMap: DrawingMap): void {
        if (!drawingMap.workspace || !drawingMap.layer) {
            return;
        }
        if (this.activeDrawingMapOverlays.has(drawingMap.id)) {
            this.removeDrawingMapOverlay(drawingMap.id);
        } else {
            this.setMapType('BGT');
            const imageMapType = this.buildDrawingMapImageType(drawingMap);
            this.googleMap.googleMap.overlayMapTypes.push(imageMapType);
            this.activeDrawingMapOverlays.set(drawingMap.id, imageMapType);
        }
    }

    removeAllDrawingMapOverlays() {
        this.selectedDrawingMaps.forEach(drawingMap => {
            if (this.activeDrawingMapOverlays.has(drawingMap.id)) {
                this.removeDrawingMapOverlay(drawingMap.id);
            }
        });
    }

    isDrawingMapOverlayActive(drawingMap: DrawingMap): boolean {
        return this.activeDrawingMapOverlays.has(drawingMap.id);
    }

    private removeDrawingMapOverlay(drawingMapId: number): void {
        const imageMapType = this.activeDrawingMapOverlays.get(drawingMapId);
        if (!imageMapType) {
            return;
        }
        const overlays = this.googleMap.googleMap.overlayMapTypes;
        const idx = overlays.getArray().indexOf(imageMapType);
        if (idx !== -1) {
            overlays.removeAt(idx);
        }
        this.activeDrawingMapOverlays.delete(drawingMapId);
    }

    private syncDrawingMapOverlays(newSelectedMaps: DrawingMap[]): void {
        const newIds = new Set(newSelectedMaps.map(dm => dm.id));
        for (const id of this.activeDrawingMapOverlays.keys()) {
            if (!newIds.has(id)) {
                this.removeDrawingMapOverlay(id);
            }
        }
    }

    private geoServerTileUrl(workspace: string, layer: string, z: number, x: number, y: number): string {
        return `${Settings.API_ENDPOINT}geoserver/tiles/${workspace}/${layer}/${z}/${x}/${y}?access_token=${LocalStorage.userToken}`;
    }

    private setupSearchForms(drawingId: number, withRemarkFilter: boolean = false) {
        this.subscriptions.add(this.fcSearch.valueChanges.pipe(debounceTime(250)).subscribe(searchTerm => {
            if (searchTerm) {
                searchTerm = searchTerm.trim().toLowerCase();
                this.searchResults = this.project.ttms.filter(ttm => {
                    if (searchTerm?.length > 1) {
                        const foundInEntityAttr = searchTerm?.length > 2 && ttm.entities.filter(e => Object.values(e.attr).map(e => `${e}`.toLowerCase().trim()).join(' ').includes(searchTerm))?.length > 0;
                        const foundOnEntityName = ttm.entities.filter(entity => entity.name.toLowerCase().includes(searchTerm))?.length > 0;
                        const foundOnType = this.ttmTypes?.find(t => t.key === ttm.type_key)?.name?.toLowerCase().includes(searchTerm);
                        const foundOnStatus = this.ttmStatuses?.find(s => s.key === ttm.status_key)?.name?.toLowerCase().includes(searchTerm);
                        return foundOnEntityName || foundOnType || foundOnStatus || foundInEntityAttr;
                    } else {
                        return ttm.entities.filter(e => Object.values(e.attr).find(a => `${a}`.toLowerCase() == searchTerm))?.length > 0;
                    }
                });
            } else {
                this.searchResults = [];
            }
            this.cdref.detectChanges();
        }));
        this.fgType = new UntypedFormGroup(this.ttmTypes.reduce((controls, ttmType) => {
            controls[ttmType.key] = new FormControl(true);
            return controls;
        }, {}));
        this.fgStatus = new UntypedFormGroup(this.ttmStatuses.reduce((controls, ttmStatus) => {
            controls[ttmStatus.key] = new FormControl(true);
            return controls;
        }, {}));
        this.fcTypeAll = new FormControl<boolean>(true);
        this.subscriptions.add(this.fgType.valueChanges.subscribe(values => {
            const allChecked = Object.values(values).every(value => value === true);
            this.fcTypeAll.setValue(allChecked, {emitEvent: false});
        }));
        this.subscriptions.add(this.fcTypeAll.valueChanges.subscribe(checked => {
            this.fgType.setValue(
                Object.keys(this.fgType.controls).reduce((acc, key) => {
                    acc[key] = checked;
                    return acc;
                }, {})
            );
        }));

        this.fgOther = new UntypedFormGroup({
            withRemark: new FormControl(withRemarkFilter)
        });
        this.fcOtherAll = new FormControl<boolean>(withRemarkFilter);
        this.subscriptions.add(this.fgOther.valueChanges.subscribe(values => {
            const allChecked = Object.values(values).every(value => value === true);
            this.fcOtherAll.setValue(allChecked, {emitEvent: false});
        }));
        this.subscriptions.add(this.fcOtherAll.valueChanges.subscribe(checked => {
            this.fgOther.setValue(
                Object.keys(this.fgOther.controls).reduce((acc, key) => {
                    acc[key] = checked;
                    return acc;
                }, {})
            );
        }));

        this.fcStatusAll = new FormControl<boolean>(true);
        this.subscriptions.add(this.fgStatus.valueChanges.subscribe(values => {
            const allChecked = Object.values(values).every(value => value === true);
            this.fcStatusAll.setValue(allChecked, {emitEvent: false});
        }));
        this.subscriptions.add(this.fcStatusAll.valueChanges.subscribe(checked => {
            this.fgStatus.setValue(
                Object.keys(this.fgStatus.controls).reduce((acc, key) => {
                    acc[key] = checked;
                    return acc;
                }, {})
            );
        }));

        this.fcSelectedTtm = new FormControl<number>(null);
        this.fcHideOutsideWorkorder = new FormControl(true);
        this.subscriptions.add(this.fcSelectedTtm.valueChanges.subscribe(() => {
            this.setTtmInUrl(this.fcSelectedTtm.value);
            if (this.fcSelectedTtm.value) {
                const ttm = this.selectedTtm = this.filteredTtms.find(ttm => ttm.id === this.fcSelectedTtm.value);
                this.subscriptions.add(this.ttmImageService.getTtmImages(ttm.id).subscribe(images => {
                    this.ttmImagesMap.set(ttm.id, images.data);
                    this.ttmImagesMap.get(ttm.id).forEach(image => {
                        this.ttmImageDistance.set(image.id, Utils.ttmEntityDistance(ttm, image));
                    });
                    this.refreshTtmImagesWithMultiple();
                }));
            } else {
                this.selectedTtm = null;
            }
        }));

        this.fgWorkorder = new UntypedFormGroup(this.project.workorders.reduce((controls, workorder) => {
            controls[workorder.id] = new FormControl(false);
            return controls;
        }, {}));
        this.fcWorkorderAll = new FormControl<boolean>(true);
        this.fcWorkorderIncluding = new FormControl<boolean>(true);
        this.subscriptions.add(this.fgWorkorder.valueChanges.subscribe(values => {
            const allChecked = Object.values(values).every(value => value === true);
            this.fcWorkorderAll.setValue(allChecked, {emitEvent: false});
        }));
        this.subscriptions.add(this.fcWorkorderAll.valueChanges.subscribe(checked => {
            this.fgWorkorder.setValue(
                Object.keys(this.fgWorkorder.controls).reduce((acc, key) => {
                    acc[key] = checked;
                    return acc;
                }, {})
            );
        }));

        this.fgDrawings = new UntypedFormGroup(this.project.drawings.reduce((controls, drawing) => {
            controls[drawing.id] = new FormControl(false);
            return controls;
        }, {}));
        if (this.project.drawings.length) {
            const workorderDrawings = (this.workorder ?? this.composingWorkorder)?.drawings?.filter(d => !!d.drawing_id);
            if (+drawingId > 0) {
                this.fgDrawings.controls[drawingId]?.setValue(true);
            } else if (workorderDrawings?.length > 0) {
                workorderDrawings.forEach(wod => {
                    this.fgDrawings.controls[wod.drawing_id]?.setValue(true);
                });
            } else if (this.project.drawings.filter(d => d.entities_count > 0)[0]?.id) {
                this.fgDrawings.controls[this.project.drawings.filter(d => d.entities_count > 0)[0]?.id].setValue(true);
            } else {
                this.fgDrawings.controls[this.project.drawings[0]?.id].setValue(true);
            }
        }

        const loadedDrawingIds = [];
        let loadedWorkorderTtms = false;
        let needsCenter = true;

        setTimeout(() => {
            this.subscriptions.add(combineLatest([
                this.fgType.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fgType.value)),
                this.fgStatus.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fgStatus.value)),
                this.fgDrawings.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fgDrawings.value)),
                this.fgWorkorder.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fgWorkorder.value)),
                this.fcWorkorderIncluding.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fcWorkorderIncluding.value)),
                this.fcHideOutsideWorkorder.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fcHideOutsideWorkorder.value)),
                this.fgOther.valueChanges.pipe(debounceTime(100)).pipe(startWith(this.fgOther.value)),
                this.ttmUpdateSubject.asObservable().pipe(debounceTime(100)).pipe(startWith(null))
            ]).subscribe(([types, statuses, drawings, workorders, workordersIncluding, hideOutsideWorkorder, other]) => {
                this.ngZone.run(() => {
                    if (this.project) {
                        const selectedDrawingIds = new Set(Object.keys(drawings).filter(id => drawings[id]).map(id => +id));
                        this.selectedDrawingMaps = this.project.drawings
                            ?.filter(d => selectedDrawingIds.has(d.id))
                            .flatMap(d => d.drawing_maps ?? [])
                            .filter((dm, i, arr) => arr.findIndex(m => m.id === dm.id) === i);
                        this.syncDrawingMapOverlays(this.selectedDrawingMaps);

                        const filterTtms = () => {
                            const anyDrawingSelected = this.project.workorders.map(wo => this.fgWorkorder.value[wo.id]).filter(w => !!w)?.length;
                            this.scopedTtms = this.project.ttms?.filter(ttm => {

                                const filterByDrawing = ttm.entities[0]?.drawing_ids?.filter(drawingId => drawings[drawingId])?.length > 0;
                                const ttmInWorkorder = this.workorder?.workorders_has_ttms?.some(woht => woht.ttm_id === ttm.id);
                                if (this.viewState.vakmanMode) {
                                    return hideOutsideWorkorder ? ttmInWorkorder && filterByDrawing : filterByDrawing;
                                }
                                return true;
                            });
                            this.filteredTtms = Utils.sortTtms(this.scopedTtms?.filter(ttm => {
                                const filterByType = types[ttm.type_key];
                                const filterByStatus = statuses[ttm.status_key];
                                const filterByDrawing = ttm.entities[0]?.drawing_ids?.filter(drawingId => drawings[drawingId])?.length > 0;
                                const ttmInSelectedWorkorders = this.project.workorders.filter(wo => !!workorders[wo.id]).some(wo => wo.workorders_has_ttms.some(woht => woht.ttm_id === ttm.id));
                                const filterByWorkorder = workordersIncluding && anyDrawingSelected ? ttmInSelectedWorkorders : !ttmInSelectedWorkorders;
                                const filterByRemark = !other.withRemark || (ttm.comment && ttm.comment.trim().length > 0);
                                const ttmFilter = this.viewState.vakmanMode || (filterByWorkorder && filterByDrawing);
                                return filterByType && filterByStatus && ttmFilter && filterByRemark;
                            }));
                            this.filteredEntities = this.project.entities?.filter(entity => {
                                return entity.drawing_ids?.filter(drawingId => drawings[drawingId])?.length > 0;
                            });
                        };

                        const loadTtms = (drawingId?: number, workorderId?: number) => {
                            this.subscriptions.add(combineLatest([
                                this.ttmService.getTtms(drawingId, workorderId),
                                this.ttmService.getTtmsImages(drawingId, workorderId)
                            ]).subscribe(([ttms, entityImages]) => {
                                if (!Array.isArray(this.project.ttms)) {
                                    this.project.ttms = [];
                                }
                                if (!Array.isArray(this.project.entities)) {
                                    this.project.entities = [];
                                }
                                if (ttms.data.ttms.length === 0) {
                                    if (this.workorder && this.workorder.ttms_count === 0) {
                                        this.confirmDialog.confirm(
                                            'Deze werkopdracht heeft geen maatregelen',
                                            `Er zijn geen maatregelen gekoppeld aan deze werkopdracht. Via de filterbalk kunnen tekeningen worden geopend.`,
                                            'Sluiten',
                                            null
                                        ).then(() => {

                                        });
                                    } else if (this.project.drawings?.length === 0) {
                                        this.confirmDialog.confirm(
                                            'Dit project heeft geen tekeningen',
                                            `Sla een bijlage op voor een van de werkopdrachten startend met de naam van de tekening om te zorgen dat tekeningen worden geïmporteerd.`,
                                            'Sluiten',
                                            null
                                        ).then(() => {

                                        });
                                    } else {
                                        this.confirmDialog.confirm(
                                            'Deze tekening heeft geen maatregelen',
                                            `Mogelijk is er iets misgegaan bij de conversie. <br><br> Tekening: <i>${this.project.drawings.find(d => d.id === +drawingId)?.name ?? drawingId}</i>.`,
                                            'Sluiten',
                                            null
                                        ).then(() => {

                                        });
                                    }

                                }

                                ttms.data.entities.forEach(entity => {
                                    entity.plain_image = entityImages.data.find(ei => ei.id === entity.plain_image_id);
                                    entity.gnd_image = entityImages.data.find(ei => ei.id === entity.gnd_image_id);
                                    entity.projected_image = entityImages.data.find(ei => ei.id === entity.projected_image_id);
                                });
                                ttms.data.ttms.forEach(ttm => {
                                    ttm.type = this.ttmTypes?.find(ttmType => ttmType.key == ttm.type_key);

                                    ttm.entities.forEach(entity => {
                                        entity.plain_image = entityImages.data.find(ei => ei.id === entity.plain_image_id);
                                        entity.gnd_image = entityImages.data.find(ei => ei.id === entity.gnd_image_id);
                                        entity.projected_image = entityImages.data.find(ei => ei.id === entity.projected_image_id);
                                    });
                                });

                                this.project.entities = [
                                    ...this.project.entities.filter(ttm => !ttms.data.entities.some(e => e.id === ttm.id)),
                                    ...ttms.data.entities
                                ];
                                this.project.ttms = [
                                    ...this.project.ttms.filter(ttm => !ttms.data.ttms.some(t => t.id === ttm.id)),
                                    ...ttms.data.ttms
                                ];
                                this.project.ttms.forEach(ttm => {
                                    ttm.type = this.ttmTypes.find(ttmType => ttmType.key === ttm.type_key);
                                    ttm.status = this.ttmStatuses.find(ttmStatus => ttmStatus.key === ttm.status_key);
                                });
                                filterTtms();
                                this.loadTtmImagesWithMultiple();
                                // center if loaded from url
                                if (needsCenter) {
                                    needsCenter = false;
                                    const pointsWithoutOutliers = this.removeOutliers(this.project.ttms);
                                    const [minLng, minLat, maxLng, maxLat] = turf.bbox(pointsWithoutOutliers);
                                    Utils.googleMapsCore().then(() => {
                                        const bounds = new google.maps.LatLngBounds(
                                            new google.maps.LatLng(minLat, minLng),
                                            new google.maps.LatLng(maxLat, maxLng)
                                        );
                                        this.googleMap.fitBounds(bounds);
                                    });

                                    from(this.filteredTtms).pipe(
                                        mergeMap(ttm => from(ttm.entities.map(e => e.gnd?.coordinates?.[0] as [number, number]))), // Flatten and extract [lng, lat]
                                        filter(coord => !!coord), // Remove null/undefined values
                                        reduce((acc, [lng, lat]) => ([...acc, {lng, lat}]), []), // Collect coords in array
                                        map(coords => coords.length
                                            ? {
                                                lat: coords.reduce((sum, {lat}) => sum + lat, 0) / coords.length,
                                                lng: coords.reduce((sum, {lng}) => sum + lng, 0) / coords.length
                                            }
                                            : null
                                        )
                                    ).subscribe(center => center);
                                }
                                this.cdref.detectChanges();
                            }));
                        }

                        const loadDrawingIds = this.viewState.vakmanMode && hideOutsideWorkorder ? [] : Object.keys(drawings).filter(drawingId => !!drawings[drawingId]);

                        loadDrawingIds.filter(d => !loadedDrawingIds.includes(d)).forEach(drawingId => {
                            loadedDrawingIds.push(drawingId);
                            loadTtms(+drawingId);
                        });
                        if (this.workorder && !loadedWorkorderTtms) {
                            loadedWorkorderTtms = true;
                            loadTtms(null, this.workorder.id);
                        }

                        filterTtms();
                        this.loadTtmImagesWithMultiple();
                    }
                });
            }));
        });
    }

    private refreshTtmImagesWithMultiple() {
        const images: TtmImage[] = [];
        if (!this.project?.ttms?.length) {
            this.ttmImagesWithMultiple = images;
            return;
        }

        this.project.ttms.forEach(ttm => {
            if ((ttm.ttm_images_count ?? 0) >= 1 && this.ttmImagesMap.has(ttm.id)) {
                images.push(...this.ttmImagesMap.get(ttm.id));
            }
        });

        // Sort by created_at (ascending, oldest first)
        images.sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();
            return dateA - dateB;
        });

        this.ttmImagesWithMultiple = images;
    }

    private loadTtmImagesWithMultiple() {
        if (this.loadingTtmImagesWithMultiple || !this.project?.ttms?.length) {
            return;
        }

        const ttmsToLoad = this.project.ttms
            .filter(ttm => (ttm.ttm_images_count ?? 0) >= 1);

        if (ttmsToLoad.length === 0) {
            this.refreshTtmImagesWithMultiple();
            return;
        }

        this.loadingTtmImagesWithMultiple = true;
        this.subscriptions.add(from(ttmsToLoad).pipe(
            mergeMap(ttm => this.ttmImageService.getTtmImages(ttm.id).pipe(
                map(response => ({ttm, images: response.data}))
            ), 4),
            reduce((acc, {ttm, images}) => {
                this.ttmImagesMap.set(ttm.id, images);
                images.forEach(image => {
                    this.ttmImageDistance.set(image.id, Utils.ttmEntityDistance(ttm, image));
                });
                return acc.concat(images ?? []);
            }, [] as TtmImage[])
        ).subscribe({
            next: () => {
            },
            complete: () => {
                this.refreshTtmImagesWithMultiple();
                this.loadingTtmImagesWithMultiple = false;
                this.cdref.detectChanges();
            },
            error: () => {
                this.loadingTtmImagesWithMultiple = false;
            }
        }));
    }


    setupGeo(center = false) {
        if (typeof navigator.geolocation !== 'undefined') {
            if (this.gpsWatchId) {
                navigator.geolocation.clearWatch(this.gpsWatchId);
            }

            this.gpsWatchId = navigator.geolocation.watchPosition(location => {
                this.viewState.gpsFailure = false;
                this.gpsLocation = {
                    lat: location.coords.latitude,
                    lng: location.coords.longitude
                };
                if (center) {
                    this.center = this.gpsLocation;
                }
                this.cdref.detectChanges();
            }, () => {
                this.gpsLocation = null;
                this.viewState.gpsFailure = true;
                this.cdref.detectChanges();
            }, {
                enableHighAccuracy: true
            });
        } else {
            setTimeout(() => {
                this.setupGeo();
            }, 5000);
        }
    }

    centerGps() {
        if (this.gpsLocation && !this.viewState.gpsFailure) {
            this.center = null;
            setTimeout(() => {
                this.center = this.gpsLocation;
                this.cdref.detectChanges();
            });
        } else {
            this.confirmDialog.confirm(
                'Locatie niet toegestaan',
                'Geef toegang tot je locatie om deze functionaliteit te gebruiken.',
                'Opnieuw proberen',
                'Geen GPS gebruiken').then(() => {
                this.setupGeo(true);
            }, () => {
            });
        }
    }

    toggleSelection() {
        this.selectionEnabled = !this.selectionEnabled;
        if (!this.selectionEnabled) {
            this.selectionPolygon = null;
        }
    }

    addPointToSelection(event) {
        if (this.selectionEnabled) {
            this.selectionPolygon = [...this.selectionPolygon ?? [], {lat: event?.latLng?.lat(), lng: event?.latLng?.lng()}];
        }
    }

    removePointFromSelectionPolygon(event, index) {
        this.selectionPolygon.splice(index, 1);
        this.selectionPolygon = [...this.selectionPolygon];
    }

    changeSelectionPolygon(event, index) {
        this.selectionPolygon[index] = {lat: event?.latLng?.lat(), lng: event?.latLng?.lng()};
        this.selectionPolygon = [...this.selectionPolygon];
    }

    ttmTicket(ttm: Ttm) {
        this.dialog.open(TtmTicketDialogComponent, {
            width: '850px',
            maxWidth: '98vw',
            data: {ttm, project: this.project, ttmStatuses: this.ttmStatuses, ttmTypes: this.ttmTypes}
        });
    }

    openImage(image: TtmImage) {
        if (this.isMobileViewport) {
            const dialogRef = this.dialog.open(ImageViewerComponent, {
                panelClass: 'image-viewer',
                width: '100vw',
                height: '100vh',
                maxWidth: '100vw',
                hasBackdrop: true,
                data: {
                    currentImage: image,
                    images: this.ttmImagesMap.get(image.ttm_id),
                    ttmStatuses: this.ttmStatuses,
                    ttmImageDistance: this.ttmImageDistance
                }
            });

            dialogRef.afterClosed().subscribe((result: { location: any, ttmId: number } | undefined) => {
                if (result) {
                    if (result.location) {
                        this.googleMap.panTo({lat: result.location.coordinates[1], lng: result.location.coordinates[0]});
                        this.googleMap.zoom = 15;
                    } else {
                        const ttm = this.project?.ttms?.find(t => t.id === result.ttmId);
                        if (ttm) {
                            this.zoomToTtm(ttm, true, true);
                        }
                    }
                }
            });
        } else {
            this.imageDrawerCurrentImage = image;
            this.viewState.imageDrawer = true;
            this.activeTtm = null;
        }
    }

    ttmDetails(ttm: Ttm) {
        this.dialog.open(TtmDetailsDialogComponent, {
            width: '700px',
            maxWidth: '98vw',
            data: {ttm, project: this.project, ttmStatuses: this.ttmStatuses, ttmTypes: this.ttmTypes}
        });
    }

    ttmHistory(ttm: Ttm) {
        const dialogRef = this.dialog.open(TtmHistoryDialogComponent, {
            width: '900px',
            maxWidth: '98vw',
            data: {ttm, ttmStatusses: this.ttmStatuses, ttmTypes: this.ttmTypes}
        });


        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result && Array.isArray(result)) {
                    const markers = result
                        .filter(history => history['position'] && history.field === 'status_key')
                        .map(history => ({
                            id: history.id,
                            position: {
                                lat: history['position'].coordinates[0],
                                lng: history['position'].coordinates[1]
                            },
                            status_key: history.new_value,
                            ttm: ttm,
                            title: `Status gewijzigd naar ${this.ttmStatuses.find(s => s.key === history.new_value)?.name ?? history.new_value} op ${new Date(history.created_at).toLocaleDateString('nl-NL', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })} door ${history.changed_by?.name ?? 'Onbekend'}`,
                        }));
                    this.historyMarkers.set(markers);
                    this.cdref.detectChanges();

                    const itemBbox = ttm.entities[0].bbox ?? ttm.entities[0].line ?? ttm.entities[0].gnd;
                    const coordinates = [];
                    coordinates.push(turf.point(itemBbox.coordinates[0] as any));
                    coordinates.push(turf.point(itemBbox.coordinates[1] as any));
                    coordinates.push(turf.point(ttm.entities[0].gnd.coordinates[0] as any));
                    const bbox = turf.buffer(turf.bboxPolygon(turf.bbox(turf.featureCollection(coordinates))), 15, {units: 'meters'});
                    const [minLng, minLat, maxLng, maxLat] = turf.bbox(bbox);
                    Utils.googleMapsCore().then(() => {
                        const bounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(minLat, minLng),
                            new google.maps.LatLng(maxLat, maxLng)
                        );

                        markers.forEach(marker => {
                            bounds.extend(new google.maps.LatLng(marker.position.lat, marker.position.lng));
                        });

                        this.googleMap.fitBounds(bounds);
                    });
                }
            },
            error: (error) => {
                console.error('Error after closing dialog', error);
            }
        })

    }

    changeCenter = (newCenter: { lat: number; lng: number; }) => {
        this.center = newCenter;
        this.cdref.detectChanges();
    }

    get selectedDrawingIds(): number[] {
        if (!this.fgDrawings) {
            return [];
        }
        return Object.keys(this.fgDrawings.value)
            .filter(id => this.fgDrawings.value[id])
            .map(id => +id);
    }

    onTtmAdded(ttm: Ttm) {
        ttm.status = this.ttmStatuses.find(s => s.key === ttm.status_key);
        ttm.type = this.ttmTypes.find(t => t.key === ttm.type_key);
        if (!Array.isArray(this.project.ttms)) {
            this.project.ttms = [];
        }
        this.project.ttms.push(ttm);
        if (this.workorder?.workorders_has_ttms) {
            this.workorder.workorders_has_ttms.push({
                ttm_id: ttm.id,
                workorder_id: this.workorder.id
            });
        }
        this.ttmUpdateSubject.next(true);
        this.activeTtm = ttm;
        this.filteredTtms.push(ttm);
        this.zoomToTtmId(ttm.id);
        this.viewState.imageDrawer = false;
    }

    mergeTtms = () => {
        const ttm = this.selectedTtm;
        const location = ttm.entities[0].bbox.coordinates[0];
        const nearbyTtms = [...this.filteredTtms.filter(ttm => !!ttm.entities.find(e => !!e.bbox))].sort((a, b) => {
            const diffA = turf.distance(turf.point(location as any), turf.point(a.entities.filter(e => !!e.bbox)[0].bbox.coordinates[0] as any));
            const diffB = turf.distance(turf.point(location as any), turf.point(b.entities.filter(e => !!e.bbox)[0].bbox.coordinates[0] as any));
            return diffA - diffB;
        });

        const ref = this.dialog.open(TtmMergeComponent, {
            width: '500px',
            maxWidth: '98vw',
            data: {ttm, nearbyTtms}
        });
        const subs = ref.afterClosed().subscribe((toUpdate: { remove: Ttm[] }) => {
            if (toUpdate.remove?.length > 0) {
                if (this.project?.ttms) {
                    this.project.ttms = this.project.ttms.filter(ttm => !toUpdate.remove.includes(ttm));
                }
                this.ttmUpdateSubject.next(true);
                ttm.entities.forEach(entity => {
                    entity.imageLoading = true;
                });
                this.subscriptions.add(this.ttmService.regeneratePlainImage(ttm.id).subscribe(image => {
                    ttm.entities.forEach(entity => {
                        entity.plain_image.svg = image.data.svg;
                        entity.plain_image_id = image.data.id;
                        entity.updateImage?.emit();
                        entity.imageLoading = false;
                    }, error => {
                        console.error(error);
                        ttm.entities.forEach(entity => {
                            entity.imageLoading = false;
                        });
                    });
                }));
            }
            subs.unsubscribe();
        });
    }

    splitTtm = () => {
        const existingTtm = this.selectedTtm;

        const ref = this.dialog.open(TtmSplitComponent, {
            width: '500px',
            maxWidth: '98vw',
            data: {ttm: existingTtm}
        });
        const subs = ref.afterClosed().subscribe((result: { ttm: Ttm, newTtm: Ttm }) => {
            const existingEntities = existingTtm.entities;
            existingTtm.entities = existingEntities.filter(entity => result.ttm.entities.find(e => e.id === entity.id));
            existingTtm.amount = result.ttm.amount;
            result.newTtm.entities = existingEntities.filter(entity => !result.ttm.entities.find(e => e.id === entity.id));
            result.newTtm.entities.forEach(entity => {
                entity.ttm_id = result.newTtm.id;
            });
            existingEntities.forEach(entity => {
                entity.imageLoading = true;
            });
            [existingTtm, result.newTtm].filter(ttm => !!ttm?.id).forEach(ttm => {
                this.subscriptions.add(this.ttmService.regeneratePlainImage(ttm.id).subscribe(image => {
                    ttm.entities.forEach(entity => {
                        entity.plain_image = _.clone(entity.plain_image);
                        Object.assign(entity.plain_image, image.data);
                    });
                    setTimeout(() => {
                        existingEntities.forEach(entity => {
                            entity.updateImage?.emit();
                            entity.imageLoading = false;
                        });
                    });
                }, error => {
                    console.error(error);
                    ttm.entities.forEach(entity => {
                        entity.imageLoading = false;
                    });
                }));
            });
            result.newTtm.type = this.ttmTypes.find(ttmType => ttmType.key === result.newTtm.type_key);
            result.newTtm.status = this.ttmStatuses.find(ttmStatus => ttmStatus.key === result.newTtm.status_key);
            this.project.ttms.push(result.newTtm);

            // Make sure the new ttm is loaded in workorders_has_ttms
            if (this.workorder) {
                this.subscriptions.add(this.workorderService.getWorkorder(this.workorder.id).subscribe(wo => {
                    this.workorder = wo.data;
                    this.ttmUpdateSubject.next(true);
                }));
            }


            this.ttmUpdateSubject.next(true);
            subs.unsubscribe();
        });
    }

    activeTtmOrContext(event: MouseEvent | TouchEvent, menuTrigger: HTMLDivElement, ttm: Ttm) {
        if ('button' in event) {
            if (event.button === 2) {
                if (this.contextMenuTimeout) {
                    clearTimeout(this.contextMenuTimeout);
                }
                menuTrigger.click();
            } else if (event.button === 0) {
                this.activeTtm = ttm;
                this.viewState.imageDrawer = false;
            }
        } else {
            if (event.type == 'touchstart') {
                this.contextMenuTimeout = setTimeout(() => {
                    menuTrigger.click();
                    this.contextMenuTimeout = null;
                }, 500);
            } else if (event.type == 'touchend') {
                if (this.contextMenuTimeout) {
                    clearTimeout(this.contextMenuTimeout);
                    this.activeTtm = ttm;
                    this.viewState.imageDrawer = false;
                }
            }
        }
    }

    removeOutliers(ttms: Ttm[]) {
        const entities = ttms.map(t => t.entities).flat();
        const pp = entities.filter(e => !!e.bbox).map(e => e?.bbox?.coordinates).flat().map(e => turf.point(e as any));
        pp.push(...entities.map(e => e.gnd.coordinates).flat().map(e => turf.point(e as any)));
        const points = turf.featureCollection(pp);
        const lons = points.features.map(p => p.geometry.coordinates[0]);
        const lats = points.features.map(p => p.geometry.coordinates[1]);

        function getIQR(values) {
            values.sort((a, b) => a - b);
            const q1 = values[Math.floor((values.length / 4))];
            const q3 = values[Math.ceil((values.length * (3 / 4))) - 1];
            const iqr = q3 - q1;
            return {q1, q3, iqr};
        }

        const lonIQR = getIQR(lons);
        const latIQR = getIQR(lats);

        return turf.featureCollection(points.features.filter(p => {
            let lon = p.geometry.coordinates[0];
            let lat = p.geometry.coordinates[1];
            return (lon >= lonIQR.q1 - 1.5 * lonIQR.iqr && lon <= lonIQR.q3 + 1.5 * lonIQR.iqr) &&
                (lat >= latIQR.q1 - 1.5 * latIQR.iqr && lat <= latIQR.q3 + 1.5 * latIQR.iqr);
        }));
    }

    searchZoomToTtm(ttm: Ttm) {
        if (this.viewState.ttms) {
            this.ttmClick(ttm?.id)
        }
        this.zoomToTtm(ttm, true);
    }

    zoomToTtmId(ttmId: number) {
        const ttm = this.filteredTtms.find(ttm => ttm.id === ttmId);
        if (ttm) {
            this.viewState.ttms = true;
            this.cdref.detectChanges();
            this.zoomToTtm(ttm, true);
            this.scrollToExpandedTtm(true);
        } else {
            this.subscriptions.add(this.ttmService.findReplacementTtm(ttmId).subscribe(ttm => {
                this.zoomToTtmId(ttm.data.id);
            }, () => {
                this.matSnackBar.open('TVM niet gevonden', null, {duration: 2000});
            }));
        }
    }

    zoomToTtm(ttm: Ttm, expanded: boolean, noMutatorCancel?: boolean) {
        this.historyMarkers.set([]);
        const zoomTo = () => {
            if (expanded) {
                this.fcSelectedTtm.setValue(ttm.id);
                const itemBbox = ttm.entities[0].bbox ?? ttm.entities[0].line ?? ttm.entities[0].gnd;
                const coordinates = [];
                coordinates.push(turf.point(itemBbox.coordinates[0] as any));
                coordinates.push(turf.point(itemBbox.coordinates[1] as any));
                coordinates.push(turf.point(ttm.entities[0].gnd.coordinates[0] as any));
                const bbox = turf.buffer(turf.bboxPolygon(turf.bbox(turf.featureCollection(coordinates))), 15, {units: 'meters'});
                const [minLng, minLat, maxLng, maxLat] = turf.bbox(bbox);
                Utils.googleMapsCore().then(() => {
                    const bounds = new google.maps.LatLngBounds(
                        new google.maps.LatLng(minLat, minLng),
                        new google.maps.LatLng(maxLat, maxLng)
                    );
                    this.googleMap.fitBounds(bounds, 100);
                });
            } else {
                this.fcSelectedTtm.setValue(null);
            }
            this.cdref.detectChanges();
        };
        if (this.mapMutator && !noMutatorCancel) {
            this.mapMutator.cancelMove().then(() => {
                zoomTo();
            }, () => {
            });
        } else {
            zoomTo();
        }
    }

    private resumeStatusDialog(resumeFlow: ResumedCameraFlow) {
        const ttm = this.project?.ttms?.find(t => t.id === resumeFlow.ttmId);
        if (!ttm) {
            this.logger.logEvent('CAMERA_FLOW', 'resume_failed', {reason: 'ttm_not_found', flowId: resumeFlow.flowId, ttmId: resumeFlow.ttmId});
            this.cameraFlow.clear();
            this.matSnackBar.open('TVM niet gevonden', null, {duration: 2000});
            return;
        }
        this.updateStatus(ttm, resumeFlow);
    }

    /** Keeps the selected ttm in the url, so a reload of the app brings the user back to the same ttm */
    private setTtmInUrl(ttmId: number | null) {
        const tree = this.router.createUrlTree([], {
            relativeTo: this.activeRoute,
            queryParams: {ttm: ttmId ?? null},
            queryParamsHandling: 'merge',
        });
        // replaceState does not start a router navigation, so no guards or reloads are triggered
        this.location.replaceState(this.router.serializeUrl(tree));
    }

    updateStatus(ttm: Ttm, resume?: ResumedCameraFlow) {
        this.setTtmInUrl(ttm.id);
        this.subscriptions.add(this.dialog.open(TtmStatusDialogComponent, {
            panelClass: 'confirm-dialog',
            disableClose: true,
            maxWidth: '98vw',
            width: '700px',
            data: {
                ttm,
                // After a reload the gps fix of the moment the flow was started is the best we have
                gpsLocation: resume?.gpsLocation ?? this.gpsLocation,
                projectId: this.projectId,
                resume,
            }
        }).afterClosed().subscribe(newStatus => {
            if (newStatus) {
                this.ngZone.run(() => {
                    ttm.status_key = newStatus;
                    ttm.status_date = new Date();
                    ttm.status = this.ttmStatuses.find(ttmStatus => ttmStatus.key === ttm.status_key);
                });

                this.ttmUpdateSubject.next(true);
            }
        }));
    }

    commentEntity(ttm: Ttm): Entity {
        return ttm.entities?.find(entity => !!entity.bbox) ?? ttm.entities?.[0];
    }

    ttmClick = (ttmId: number) => {
        this.historyMarkers.set([]);
        const ttmBarNotOpen = this.viewState.ttms !== true;
        this.viewState.ttms = true;

        if (!this.mapMutator?.movingEntity) {
            this.fcSelectedTtm.setValue(ttmId);
            this.scrollToExpandedTtm(ttmBarNotOpen);
        }
        this.cdref.detectChanges();
    }

    scrollToExpandedTtm(ttmBarNotOpen?: boolean) {
        setTimeout(() => {
            const expandedPanel = this.ttmList.nativeElement.querySelector('.mat-expanded');

            if (expandedPanel) {
                expandedPanel.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }, ttmBarNotOpen ? 1000 : 0);
    }

    deleteTtm(ttm: Ttm) {
        this.confirmDialog.confirm('Verwijderen TVM',
            `Weet je zeker dat je de ${ttm.type?.name ?? 'TVM'} "${ttm.id}" wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.subscriptions.add(this.ttmService.delete(ttm.id).subscribe(() => {
                this.ngZone.run(() => {
                    this.project.ttms = this.project.ttms.filter(item => item.id !== ttm.id);
                    this.filteredTtms = this.filteredTtms.filter(item => item.id !== ttm.id);
                    this.activeTtm = null;
                });
            }));
        });
    }

    toggleMapType() {
        const usedTypes = [
            google.maps.MapTypeId.ROADMAP,
            'BGT',
            google.maps.MapTypeId.HYBRID,
            'OSM'
        ];
        this.mapTypeId = usedTypes[usedTypes.indexOf(this.mapTypeId) + 1] ?? usedTypes[0] as any;
    }

    setMapType(mapType: any) {
        this.mapTypeId = mapType;
        if (this.mapTypeId !== 'BGT') {
            this.removeAllDrawingMapOverlays();
        }
    }

    @HostListener('document:keydown.escape', ['$event'])
    override handleEscape(event: KeyboardEvent) {
        if (!event || this.platformService.ANDROID) {
            return true;
        }
        if (this.dialog?.openDialogs?.length > 0) {
            this.dialog.openDialogs[this.dialog.openDialogs.length - 1].close();
            return false;
        }
        if (this.activeTtm) {
            this.activeTtm = null;
            return false;
        }
        if (this.viewState.search) {
            this.viewState.search = false;
            return false;
        }
        if (this.viewState.filter) {
            this.viewState.filter = false;
            return false;
        }
        if (this.viewState.workorder) {
            this.viewState.workorder = false;
            return false;
        }
        if (this.viewState.ttms) {
            this.viewState.ttms = false;
            return false;
        }
        return true;
    }

    reload() {
        document.location.reload();
    }

    toggleFilterBar() {
        this.viewState.search = false;
        this.viewState.filter = !this.viewState.filter;
    }

    toggleWorkorder() {
        this.viewState.workorder = !this.viewState.workorder;
    }

    toggleSearchBar() {
        this.viewState.filter = false;
        this.viewState.search = !this.viewState.search;
        if (this.viewState.search) {
            setTimeout(() => {
                (document.querySelector('#ttmSearchInput') as HTMLInputElement).focus();
            });
        }
    }

    updateImages(ttmImages: TtmImage[]) {
        if (this.activeTtm) {
            this.ttmImagesMap.set(this.activeTtm.id, ttmImages);
            this.refreshTtmImagesWithMultiple();
        }
    }

    entityPolygonClick(entity: Entity) {
        this.confirmDialog.confirmClose(entity?.name, `Dit is een ${entity?.name}`);
    }

    copyTtmLink(ttm: Ttm) {
        const url = new URL(this.env.apiEndpoint + `${Routenames.Projects}/` + ttm.project_id);
        url.searchParams.set('ttm', ttm.id.toString());
        url.searchParams.set('drawingId', ttm.entities[0]?.drawing_ids?.[0]?.toString() ?? '');

        navigator.clipboard.writeText(url.toString());
        this._snackBar.open('Link naar TVM gekopieerd naar klembord', null, {duration: 3000});
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        this.cancelCloseMapMenu();
        this.ttmToggleResizeObserver.disconnect();
        clearInterval(this.ttmZoomInterval);

        if (this.gpsWatchId) {
            navigator.geolocation.clearWatch(this.gpsWatchId);
        }
    }

    onImageDrawerImageChange(image: TtmImage) {
        if (!image) return;

        const ttm = this.project?.ttms?.find(t => t.id === image.ttm_id);
        if (ttm) {
            this.zoomToTtm(ttm, true, true);
            this.scrollToExpandedTtm();
            this.imageDrawerCurrentImage = image;
        }
    }

    onLocationOpen(location: { type: string, coordinates: [number, number] } | null) {
        if (location) {
            this.googleMap.panTo({lat: location.coordinates[1], lng: location.coordinates[0]});
            this.googleMap.zoom = 15;
        } else {
            const ttm = this.project?.ttms?.find(t => t.id === this.imageDrawerCurrentImage?.ttm_id);
            if (ttm) {
                this.zoomToTtm(ttm, true, true);
            }
        }
    }

    openMapMenu(): void {
        if (this.isMobileViewport) return;

        this.cancelCloseMapMenu();

        if (!this.mapMenuTrigger?.menuOpen) {
            this.menuOpen = true;
            this.mapMenuTrigger.openMenu();
        }
    }

    scheduleCloseMapMenu(): void {
        if (this.isMobileViewport) return;

        this.cancelCloseMapMenu();

        this.closeMapMenuTimeout = window.setTimeout(() => {
            this.closeMapMenu();
        }, 150);
    }

    cancelCloseMapMenu(): void {
        if (this.closeMapMenuTimeout) {
            window.clearTimeout(this.closeMapMenuTimeout);
            this.closeMapMenuTimeout = undefined;
        }
    }

    onMapMenuClosed(): void {
        this.menuOpen = false;
        this.cancelCloseMapMenu();
    }

    closeMapMenu(): void {
        this.cancelCloseMapMenu();

        if (this.mapMenuTrigger?.menuOpen) {
            this.mapMenuTrigger.closeMenu();
        }

        this.menuOpen = false;
    }

    protected readonly TtmStatus = TtmStatus;
    protected readonly TtmTypes = TtmTypes;
}
